import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { CurrentUserContext } from '../../context/CurrentUserContext';

function ExpiredLink({ error }) {
  const navigate = useNavigate();
  const { setCurrentUser } = useContext(CurrentUserContext);

  useEffect(() => {
    (async () => {
      await new Promise(resolve => setTimeout(resolve, 3000));
      setCurrentUser(null);
      localStorage.removeItem('currentUser');
      navigate('/login', { replace: true });
    })();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        padding: '1rem',
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        The link you followed has expired. Redirecting to login...
      </Typography>
    </Box>
  );
}

export { ExpiredLink };
export default ExpiredLink;